import React from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {Select} from "@morningtrain/react-fields";
import useFilterValue from "../hooks/use-filter-value";
import useWillConstrain from "../hooks/use-will-constrain";

function EnumFilter(props) {

    const [value, setValue] = useFilterValue(props.name);

    useWillConstrain(props.name, value);

    return (
        <Select placeholder={props.placeholder}
                enum={props.enum}
                only={props.only}
                className={props.className}
                label={props.label}
                defaultValue={value}
                onChange={selectedValue => setValue(selectedValue)}/>
    );
}

EnumFilter.defaultProps = {
    label: null,
    only: null,
};

EnumFilter.propTypes = {
    className: PropTypes.string,
    enum: PropTypes.string.isRequired,
    label: PropTypes.node,
    name: PropTypes.string.isRequired,
    only: PropTypes.array,
    placeholder: PropTypes.string,
};

export default observer(EnumFilter);
